export default function(string, max = 40) {
  if ((string || "").length > max) {
    return string.substring(0, max) + "...";
  }
  return string;
}
